export default __webpack_public_path__ + "static/char-v-37-ja-71baae3f15180e7ed3896bbab3b4bf1d.mp4";